import { PinsItemModel } from 'Models';
import { stringToLocation } from 'Utils';
import mapCalculateDistance from './MapCalculateDistance';

type centerOfMapType = {
  lat: number;
  lng: number;
};

const filterPointsForCenterOfMap = (pointList: PinsItemModel[], centerOfMap: centerOfMapType) => {
  let newPins: PinsItemModel[] = [];
  for (const item of pointList) {
    const distance = mapCalculateDistance({
      latitude: centerOfMap.lat,
      longitude: centerOfMap.lng,
      pointLatitude: stringToLocation(item.Latitude),
      pointLongitude: stringToLocation(item.Longitude),
    });
    if (Number(distance) <= 2.5) {
      newPins.push(item);
    }
  }
  return newPins;
};

export default filterPointsForCenterOfMap;
